import type { Cart } from '@src/domains/cart/types/cart';
import { hasCartErrors } from '@src/domains/cart/core/hasCartErrors';
import { hasCheckoutableItems } from '@src/domains/cart/core/hasCheckoutableItems';

export const isCartReady = (input: { cart?: Cart; couponErrors?: string[] }): boolean =>
  hasCheckoutableItems(input) && !hasCartErrors(input.cart);
